import { Field, ID, Int, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { MilkPickupRouteCustomerRef } from './MilkPickupRouteCustomerRef'

@ObjectType()
export class MilkPickupRouteDetailRef {
  @Field(() => ID, { nullable: true })
  @Prop({ type: String })
  _id?: string

  @Field(() => MilkPickupRouteCustomerRef, { nullable: true })
  @Prop({ type: MilkPickupRouteCustomerRef })
  customer?: ReturnType<() => MilkPickupRouteCustomerRef>

  @Field(() => Int, { nullable: true })
  @Prop({ type: Number })
  position?: number
}
